import React from "react";
import { Outlet } from "react-router-dom"; // [수정] Outlet import 추가

// 모바일에서는 사이드바가 필요 없다면 제거하거나,
// 추후 Drawer 메뉴로 쓸 예정이라면 주석 처리해두세요.
/*
import SidebarLayout from "../../components/common/layout/SidebarLayout";

const sections = [
  {
    title: "전체 게시판",
    items: [{ to: "list/all", label: "품질 문서 전체", end: true }],
  },
  // ... (생략)
];
*/

export default function QualityLayout() {
  return (
    <div className="w-full min-w-0 overflow-x-hidden flex justify-center mb-16 px-4 box-border">
      <div className="w-full max-w-md min-w-0 space-y-2 sm:space-y-3">
        {/* 자식 라우트(list, new 등)가 이곳에 렌더링됩니다 */}
        <Outlet />
      </div>
    </div>
  );
}
